import { render } from "./DefaultCategoriesList.vue?vue&type=template&id=90f7c5c8&scoped=true"
import script from "./DefaultCategoriesList.vue?vue&type=script&lang=js"
export * from "./DefaultCategoriesList.vue?vue&type=script&lang=js"

import "./DefaultCategoriesList.vue?vue&type=style&index=0&id=90f7c5c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90f7c5c8"]])

export default __exports__